import React from 'react';
import Icon from '../../../components/AppIcon';

const ChildProgressCard = ({ child, isSelected, onClick }) => {
  const getTimeAgo = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffInMinutes = Math.floor((now - date) / (1000 * 60));

    if (diffInMinutes < 60) return `Il y a ${diffInMinutes} min`;
    if (diffInMinutes < 1440) return `Il y a ${Math.floor(diffInMinutes / 60)} h`;
    return `Il y a ${Math.floor(diffInMinutes / 1440)} j`;
  };

  return (
    <button
      onClick={onClick}
      className={`relative bg-white rounded-xl p-6 border-2 transition-all duration-300 text-left hover:shadow-lg ${
        isSelected
          ? 'border-blue-500 shadow-md'
          : 'border-gray-200 hover:border-blue-300'
      }`}
    >
      {isSelected && (
        <div className="absolute top-4 right-4">
          <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center">
            <Icon name="Check" size={16} color="#FFFFFF" />
          </div>
        </div>
      )}

      <div className="flex items-start gap-4 mb-4">
        <div className="flex-shrink-0 w-14 h-14 bg-gradient-to-br from-blue-500 to-purple-500 rounded-full flex items-center justify-center">
          <span className="text-white text-lg font-bold">{child?.avatar}</span>
        </div>
        <div className="flex-1">
          <h3 className="text-lg font-bold text-gray-900 mb-1">{child?.name}</h3>
          <p className="text-sm text-gray-600">{child?.grade}</p>
          <p className="text-xs text-gray-500 mt-1">Âge: {child?.age} ans</p>
        </div>
      </div>

      <div className="mb-4">
        <div className="flex justify-between text-sm mb-2">
          <span className="text-gray-700">Progression</span>
          <span className="font-semibold text-gray-900">{child?.progressPercentage}%</span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-2">
          <div
            className="bg-gradient-to-r from-blue-500 to-purple-500 h-2 rounded-full transition-all duration-500"
            style={{ width: `${child?.progressPercentage}%` }}
          />
        </div>
      </div>

      <div className="bg-gray-50 rounded-lg p-3 mb-3">
        <div className="flex items-start gap-2">
          <Icon name="Activity" size={16} className="text-blue-600 mt-0.5" />
          <div className="flex-1">
            <p className="text-xs font-medium text-gray-700 mb-1">Dernière activité</p>
            <p className="text-xs text-gray-600">{child?.recentActivity}</p>
          </div>
        </div>
      </div>

      <div className="flex items-center gap-2 text-xs text-gray-500">
        <Icon name="Clock" size={14} />
        <span>{getTimeAgo(child?.lastActive)}</span>
      </div>
    </button>
  );
};

export default ChildProgressCard;